<template>
  <div>
    <!-- Test -->
    <div class="pb-3">
      <div class="section-plan">
        <div class="rumbo-layout">
          <div class="rumbo-layout__header">
            <span>Hola {{ showUserName() }}</span>
            <!--a @click="newPlan" class="btn"
              ><i class="fa fa-plus" aria-hidden="true"></i>Comprar un nuevo
              plan</a
            -->
          </div>
        </div>
      </div>
      <div
          class="loader text-center text-main"
          v-if="loading && funds.length === 0"
      >
        <span class="">Cargando p&oacute;lizas ...</span>
        <br />
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
      <div v-for="item in funds" v-bind:key="item.policyId">
        <div class="myplan">
          <div class="card asd">
            <div class="card-body">
              <div class="visible-mobile">
                <div class="row">
                  <div class="myplan__plan col-4">
                    <div>
                      <h6>Mi plan</h6>
                      <span>{{ item.referencePolicyNumber }}</span>
                    </div>
                    <div class="devolution-total">
                      <h6>S/ {{ formatNumber(item.totalAmountSavedFinal) }}</h6>
                      <span>Devolución total</span>
                    </div>
                  </div>
                  <div class="myplan__month col-4">
                    <p>{{ item.friendlyName }}</p>
                    <h1>S/ {{ formatNumber(item.paymentAmount) }}</h1>
                    <p>mensuales</p>
                  </div>
                  <div class="myplan__date col-4">
                    <span>Inicio: &nbsp;</span><span>{{ item.startDate }}</span
                  ><br />
                    <span>Fin: </span><span>{{ item.endDate }}</span>
                    <div class="status d-flex">
                      <p v-if="!item.freezed">Activo</p>
                      <p v-if="item.freezed" :class="{ freezed: item.freezed }">
                        Congelado
                      </p>
                    </div>

                    <div
                        class="myplan__date__content"
                        :class="{ open: !item.collapsed }"
                    >
                      <button
                          class="chevron"
                          @click="item.collapsed = !item.collapsed"
                      >
                        <i
                            v-if="!item.collapsed"
                            class="iconZone fa fa-chevron-up fa-2x"
                            aria-hidden="true"
                        ></i>
                        <i
                            v-if="item.collapsed"
                            class="iconZone fa fa-chevron-down fa-2x"
                            aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="hidden-mobile">
                <div class="row" style="display: flex; align-items: center">
                  <div class="myplan__plan col-4">
                    <div
                        class="row"
                        style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <div class="col-6">
                        <h6>Mi plan</h6>
                        <span>{{ item.referencePolicyNumber }}</span>
                      </div>
                      <div class="col-status col-4 pl-0 ml-0 mt-1">
                        <p>S/ {{ formatNumber(item.totalAmountSavedFinal) }}</p>
                        <span>Devolución total</span>
                      </div>
                    </div>
                  </div>
                  <div class="myplan__month col-5">
                    <p>{{ item.friendlyName }}</p>
                    <h1>S/ {{ formatNumber(item.paymentAmount) }}</h1>
                    <div
                        class="myplan__month__content"
                        style="display: flex; justify-content: center"
                    >
                      <p>mensuales</p>
                    </div>
                  </div>
                  <div class="myplan__date col-3 align-items-center d-flex" style="margin-top: -15px;">
                    <div class="myplan__date__date-pay">
                      <div class="d-flex" style="height: 21px;">
                        <span>Inicio: &nbsp;</span
                        ><span>{{ item.startDate }}</span>
                      </div>
                      <div class="d-flex">
                        <span>Fin: </span><span>{{ item.endDate }}</span>
                      </div>
                      <div class="status d-flex">
                        <p class="mb-0" v-if="!item.freezed">Activo</p>
                        <p
                            class="mb-0"
                            v-if="item.freezed"
                            :class="{ freezed: item.freezed }"
                        >
                          Congelado
                        </p>
                      </div>
                      <div
                          class="myplan__date__content"
                          :class="{ open: !item.collapsed }"
                      >
                        <button @click="item.collapsed = !item.collapsed">
                          <i
                              v-if="!item.collapsed"
                              class="iconZone fa fa-chevron-up fa-2x"
                              aria-hidden="true"
                          ></i>
                          <i
                              v-if="item.collapsed"
                              class="iconZone fa fa-chevron-down fa-2x"
                              aria-hidden="true"
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!item.collapsed">
                <div class="pay">
                  <div class="pay__title mb-4 mt-4">
                    <hr class="hidden-mobile" />
                    <div class="row">
                      <div class="my-pays col-12 col-md-6">
                        <span> Mis pagos </span>
                      </div>

                      <div
                          class="my-found col-12 col-md-6 p-0 m-0 hidden-mobile"
                      >
                        <span class="ml-3"> Mi fondo </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="visible-mobile">
                  <div class="option">
                    <div class="card">
                      <div class="card-body mb-4">
                        <div class="option__content">
                          <img
                              class="icon"
                              src="@/assets/images/app/calendar1.svg"
                              alt=""
                          />
                          <div class="description">
                            <div class="description__title">
                              <span v-if="item.completedPayments"
                              >Estás al día en tus pagos</span
                              >
                              <span v-if="!item.completedPayments"
                              >Tienes un pago pendiente</span
                              >
                              <img
                                  style="margin-left: 4px"
                                  src="@/assets/images/app/checkk.svg"
                                  alt=""
                                  v-if="item.completedPayments"
                              />
                              <img
                                  style="margin-left: 4px"
                                  src="@/assets/images/app/Exclamacion.svg"
                                  alt=""
                                  v-if="!item.completedPayments"
                              />
                            </div>
                            <div class="description__subtitle">
                              <span
                              >Próximo vencimiento:
                                {{ item.nextPaymentDateFormatted }}</span
                              >
                            </div>
                            <div class="description__content">
                              Será debitado de tu tarjeta afiliada desde:
                              {{ item.nextPaymentStartDateFormatted }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="changecard mb-4" v-if="item.debitAutomatic">
                    <div
                        class="card"
                        @click="
                        selectFund(item);
                        navigateToChangePaymentMethod();
                      "
                    >
                      <div class="card-body">
                        <div
                            class="changecard__content d-flex align-items-center"
                        >
                          <img
                              class="credit-card"
                              src="@/assets/images/app/tarjetas-de-credito.svg"
                              alt=""
                          />
                          <div class="description">
                            <div class="description__title-pink">
                              Actualiza tu tarjeta
                            </div>
                          </div>
                          <div class="action">
                            <a role="button">
                              <img
                                  src="@/assets/images/app/chevronright.svg"
                                  alt=""
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="changecard mb-4" v-if="!item.debitAutomatic">
                    <div class="card">
                      <div class="card-body">
                        <div class="changecard__content">
                          <img
                              class="credit-card"
                              src="@/assets/images/app/tarjetas-de-credito.svg"
                              alt=""
                          />
                          <div class="description">
                            <div class="description__subtitle">
                              Pagar mi aporte mensual
                            </div>
                          </div>
                          <div class="action">
                            <a
                                @click="
                                selectFund(item);
                                navigateToSinglePayment();
                              "
                            >
                              <img
                                  src="@/assets/images/app/chevronright.svg"
                                  alt=""
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="changecard mb-4">
                    <div class="card">
                      <div class="card-body">
                        <div class="changecard__content">
                          <div class="description">
                            <div class="description__subtitle" style="font-size: 14px; line-height: 18px;">
                              Para consultas, puede llamar al (01) 500-0000
                            </div>
                          </div>
                          <!--div class="action d-flex align-items-center">
                            <a href="mailto:rumbo@interseguro.com.pe">
                              <img
                                src="@/assets/images/app/chevronright.svg"
                                alt=""
                              />
                            </a>
                          </div-->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--  -->
                  <!-- <div
                    class="additionalaport"
                    v-if="
                    item.completedPayments &&
                      item.periodicity !== 4 &&
                      item.paidPayments.length >= 3 &&
                      item.additionalPaymentsNumber < 2
                    "
                  >
                    <div class="card">
                      <div class="card-body">
                        <div class="additionalaport__content">
                          <img
                            class="save"
                            src="@/assets/images/app/ahorro.svg"
                            alt=""
                          />
                          <div
                            class="description"
                            style="display: flex; align-items: center"
                          >
                            <div class="description__title">
                              Hacer un aporte adicional
                              <span
                                style="
                                  color: #15ce75;
                                  font-size: 10px;
                                  display: block;
                                  margin-top: -3px;
                                "
                                >Puedes usar este beneficio hasta 2 veces al
                                año</span
                              >
                            </div>
                          </div>
                          <div
                            class="action"
                            style="display: flex; align-items: center"
                          >
                            <a
                              @click="
                                selectFund(item);
                                navigateToAdditionalContribution();
                              "
                            >
                              <img
                                src="@/assets/images/app/chevronright.svg"
                                alt=""
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>

                <div class="hidden-mobile">
                  <div class="row">
                    <div class="col-6 align-items-center">
                      <div class="option ml-7 changecard">
                        <div class="card">
                          <div class="card-body mb-4">
                            <div class="option__content d-flex">
                              <img
                                  class="icon"
                                  src="@/assets/images/app/calendar1.svg"
                                  alt=""
                              />
                              <div class="description">
                                <div class="description__title">
                                  <span v-if="item.completedPayments"
                                  >Estás al día en tus pagos</span
                                  >
                                  <span v-if="!item.completedPayments"
                                  >Tienes un pago pendiente</span
                                  >
                                  <img
                                      style="margin-left: 4px"
                                      src="@/assets/images/app/checkk.svg"
                                      alt=""
                                      v-if="item.completedPayments"
                                  />
                                  <img
                                      style="margin-left: 4px"
                                      src="@/assets/images/app/Exclamacion.svg"
                                      alt=""
                                      v-if="!item.completedPayments"
                                  />
                                </div>
                                <div class="description__subtitle">
                                  <span
                                  >Próximo vencimiento:
                                    {{ item.nextPaymentDateFormatted }}</span
                                  >
                                </div>
                                <div class="description__content">
                                  Será debitado de tu tarjeta afiliada desde:
                                  {{ item.nextPaymentStartDateFormatted }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="changecard mb-4" v-if="item.debitAutomatic">
                        <div class="card">
                          <div class="card-body">
                            <div
                                class="changecard__content d-flex align-items-center"
                            >
                              <img
                                  class="credit-card"
                                  src="@/assets/images/app/tarjetas-de-credito.svg"
                                  alt=""
                              />
                              <div class="description">
                                <div class="description__title-pink">
                                  Actualiza tu tarjeta
                                </div>
                                <!-- <div class="description__subtitle">
                                  Actualizar datos de mi tarjeta
                                </div> -->
                              </div>
                              <div class="action">
                                <a
                                    @click="
                                    selectFund(item);
                                    navigateToChangePaymentMethod();
                                  "
                                >
                                  <img
                                      src="@/assets/images/app/chevronright.svg"
                                      alt=""
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="changecard mb-4" v-if="!item.debitAutomatic">
                        <div class="card">
                          <div class="card-body">
                            <div class="changecard__content">
                              <img
                                  class="credit-card"
                                  src="@/assets/images/app/tarjetas-de-credito.svg"
                                  alt=""
                              />
                              <div class="description">
                                <div class="description__subtitle">
                                  Pagar mi aporte mensual
                                </div>
                              </div>
                              <div class="action">
                                <a
                                    @click="
                                    selectFund(item);
                                    navigateToSinglePayment();
                                  "
                                >
                                  <img
                                      src="@/assets/images/app/chevronright.svg"
                                      alt=""
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="changecard mb-4">
                        <div class="card">
                          <div class="card-body">
                            <div class="changecard__content">
                              <div class="description">
                                <div class="description__subtitle" style="font-size: 14px; line-height: 18px;">
                                  Para consultas, puede llamar al (01) 500-0000
                                </div>
                              </div>
                              <!--div class="action d-flex align-items-center">
                                <a href="mailto:rumbo@interseguro.com.pe">
                                  <img
                                    src="@/assets/images/app/chevronright.svg"
                                    alt=""
                                  />
                                </a>
                              </div-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--  -->
                      <!-- <div
                        class="additionalaport"
                        v-if="
                          item.completedPayments &&
                          item.periodicity !== 4 &&
                          item.paidPayments.length >= 3 &&
                          item.additionalPaymentsNumber < 2
                        "
                      >
                        <div class="card">
                          <div class="card-body">
                            <div class="additionalaport__content">
                              <img
                                class="save"
                                src="@/assets/images/app/ahorro.svg"
                                alt=""
                              />
                              <div
                                class="description"
                                style="display: flex; align-items: center"
                              >
                                <div class="description__title">
                                  Hacer un aporte adicional
                                  <span
                                    style="
                                      color: #15ce75;
                                      font-size: 10px;
                                      display: block;
                                      margin-top: -3px;
                                    "
                                    >Puedes usar este beneficio hasta 2 veces al
                                    año</span
                                  >
                                </div>
                              </div>
                              <div
                                class="action"
                                style="display: flex; align-items: center"
                              >
                                <a
                                  @click="
                                    selectFund(item);
                                    navigateToAdditionalContribution();
                                  "
                                >
                                  <img
                                    src="@/assets/images/app/chevronright.svg"
                                    alt=""
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                    <div class="col-6 align-items-center">
                      <div class="pay m-0 p-0">
                        <div class="visible-mobile">
                          <div class="pay__title">
                            <span> Mi fondo </span>
                          </div>
                        </div>
                        <div class="pay__charts">
                          <div class="details">
                            <img
                                class="money"
                                src="@/assets/images/app/bolsa-de-dinero.svg"
                                alt=""
                            />
                            <div class="title">
                              <div class="info">
                                <div class="info__txt">
                                  <span>Ahorro acumulado</span>
                                </div>
                                <div class="info__subtitle">
                                  S/ {{ formatNumber(item.totalPaid) }}
                                </div>
                              </div>
                              <div class="title__content mt-1">
                                Plazo para mi meta:
                                <span class="text-capitalize">{{
                                    item.expireOnDate
                                  }}</span>
                              </div>
                            </div>
                            <div class="action">
                              <a
                                  class="mr-2"
                                  role="button"
                                  @click="previousGroup(item)"
                                  :class="{
                                  disabled: item.selectedGroup === 1,
                                }"
                              >
                                <img
                                    class="left"
                                    src="@/assets/images/app/chevronright.svg"
                                    alt=""
                                />
                              </a>
                              <a
                                  role="button"
                                  :class="{
                                  disabled:
                                    item.selectedGroup === item.ranges.length,
                                }"
                                  @click="nextGroup(item)"
                              >
                                <img
                                    class="right"
                                    src="@/assets/images/app/chevronright.svg"
                                    alt=""
                                />
                              </a>
                            </div>
                          </div>
                          <div class="chart" v-if="item.barChart">
                            <payments-chart :data="item.barChart" />
                          </div>
                          <div class="chart-loader" v-if="!item.barChart">
                            <i class="fas fa-circle-notch fa-spin"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="visible-mobile">
                  <div class="pay">
                    <div class="pay__title mb-2">
                      <span> Mi fondo </span>
                    </div>
                    <div class="pay__chart mb-4">
                      <div class="details">
                        <img
                            class="money"
                            src="@/assets/images/app/bolsa-de-dinero.svg"
                            alt=""
                        />
                        <div class="title">
                          <div class="info">
                            <div class="info__txt">
                              <span>Ahorro acumulado</span>
                            </div>
                            <div class="info__subtitle">
                              S/ {{ formatNumber(item.totalPaid) }}
                            </div>
                          </div>
                          <div class="title__content mt-1">
                            Plazo para mi meta:
                            <span class="text-capitalize">{{
                                item.expireOnDate
                              }}</span>
                          </div>
                        </div>
                        <div class="action">
                          <a
                              class="mr-2"
                              role="button"
                              @click="previousGroup(item)"
                              :class="{
                              disabled: item.selectedGroup === 1,
                            }"
                          >
                            <img
                                class="left"
                                src="@/assets/images/app/chevronright.svg"
                                alt=""
                            />
                          </a>
                          <a
                              role="button"
                              :class="{
                              disabled:
                                item.selectedGroup === item.ranges.length,
                            }"
                              @click="nextGroup(item)"
                          >
                            <img
                                class="right"
                                src="@/assets/images/app/chevronright.svg"
                                alt=""
                            />
                          </a>
                        </div>
                      </div>
                      <div class="chart" v-if="item.barChart">
                        <payments-chart :data="item.barChart" />
                        <div class="infoAport"></div>
                      </div>
                      <div class="chart-loader" v-if="!item.barChart">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="pay" v-if="item.paidPayments.length >= 6">
                  <div class="pay__title mb-4 mt-4">
                    <span> Mis solicitudes </span>
                  </div>
                </div> -->

                <div
                    class="modifyaport"
                    v-if="item.paidPayments.length >= 6 && false"
                >
                  <div
                      class="card"
                      :class="{ requested: item.endorsement || item.freezing }"
                  >
                    <div class="card-body">
                      <div class="modifyaport__content">
                        <img src="@/assets/images/app/lapiz.svg" alt="" />
                        <div class="title">
                          <span>Modificar mis aportes</span>
                          <template v-if="item.freezing">
                            <span
                            >Se habilitará esta opción luego de procesar tu
                              solicitud de congelamiento.</span
                            >
                          </template>
                          <template v-else>
                            <template v-if="!item.endorsement">
                              <span>15 días de tiempo de respuesta</span>
                              <span
                              >Puedes solicitar hasta 2 veces en total</span
                              >
                            </template>
                            <template v-if="item.endorsement">
                              <template v-if="item.endorsement.status === 1">
                                <span
                                >Cambio de aporte a S/{{
                                    item.endorsement.amount
                                  }}</span
                                >
                                <span
                                >Solicitado el
                                  {{
                                    formatDate(item.endorsement.createdOn)
                                  }}</span
                                >
                              </template>
                              <template v-if="item.endorsement.status === 2">
                                <span
                                >Cambio de aporte a S/{{
                                    item.endorsement.amount
                                  }}
                                  aceptado</span
                                >
                              </template>
                            </template>
                          </template>
                        </div>
                        <div
                            class="additionalaport__slider mt-4 hidden-mobile"
                            style="width: 258px; margin-right: 53px"
                        >
                          <div class="amount-selector">
                            <vue3-slider
                                :min="item.changeAmountSlider.min"
                                :max="item.changeAmountSlider.max"
                                :interval="item.changeAmountSlider.interval"
                                :step="10"
                                :color="'#0855c4'"
                                :track-color="'#c5c5c5'"
                                :width="'100%'"
                                :height="10"
                                :handleScale="1.5"
                                :tooltip="true"
                                :tooltipText="'S/%v'"
                                :tooltipTextColor="'#0855c4'"
                                :disabled="!!item.endorsement || !!item.freezing"
                                v-model="item.changeAmountSlider.amount"
                                @change="
                                changeAmount($event, item, 'changeAmountSlider')
                              "
                            />
                            <span class="min-number"
                            >S/
                              {{
                                formatNumber(item.changeAmountSlider.min)
                              }}</span
                            >
                            <span class="min"
                            >S/
                              {{
                                formatNumber(item.changeAmountSlider.max)
                              }}</span
                            >
                          </div>
                        </div>
                        <button
                            class="btn-request"
                            :disabled="!!item.endorsement"
                            @click="
                            selectFund(item);
                            openModalEndorsement('modal-endorsement');
                          "
                        >
                          <img src="@/assets/images/app/Cursor.svg" alt="" />
                        </button>
                        <div class="modifyaport__txt">
                          <span v-if="!item.endorsement">Solicitar</span>
                          <span
                              v-if="item.endorsement"
                              :class="{ 'text-disabled': item.endorsement }"
                          >Solicitado</span
                          >
                        </div>
                      </div>
                      <div class="additionalaport__slider visible-mobile">
                        <div class="amount-selector" style="margin-top: 25px">
                          <vue3-slider
                              :min="item.changeAmountSlider.min"
                              :max="item.changeAmountSlider.max"
                              :interval="item.changeAmountSlider.interval"
                              :step="10"
                              :color="'#0855c4'"
                              :track-color="'#c5c5c5'"
                              :width="'100%'"
                              :height="10"
                              :handleScale="1.5"
                              :tooltip="true"
                              :tooltipText="'S/%v'"
                              :tooltipTextColor="'#0855c4'"
                              :disabled="!!item.endorsement"
                              v-model="item.changeAmountSlider.amount"
                              @change="
                              changeAmount($event, item, 'changeAmountSlider')
                            "
                          />
                          <span class="min"
                          >S/
                            {{
                              formatNumber(item.changeAmountSlider.min)
                            }}</span
                          >
                          <span class="min"
                          >S/
                            {{
                              formatNumber(item.changeAmountSlider.max)
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div
                  class="freezeplan modifyaport"
                  v-if="item.paidPayments.length >= 6"
                >
                  <div
                    class="card mb-4"
                    :class="{ requested: item.freezing || item.endorsement }"
                  >
                    <div class="card-body">
                      <div class="freezeplan__content">
                        <img src="@/assets/images/app/congelar.svg" alt="" />
                        <div class="title">
                          <span>Congelar mi plan</span>
                          <template v-if="item.endorsement">
                            <span style="padding-right: 12px"
                              >Se habilitará esta opción luego de procesar tu
                              solicitud de modificación de aportes.
                            </span>
                          </template>
                          <template v-else>
                            <template v-if="!item.freezing">
                              <span>15 días de tiempo de respuesta</span>
                              <span
                                >Puedes solicitar hasta 2 veces en total</span
                              >
                            </template>
                            <template v-if="item.freezing">
                              <template v-if="item.freezing.status === 1">
                                <span>Solicitud en proceso </span>
                                <span
                                  >Solicitado el
                                  {{
                                    formatDate(item.freezing.createdOn)
                                  }}</span
                                >
                              </template>
                              <template v-if="item.freezing.status === 2">
                                <span>Solicitud aceptada </span>
                              </template>
                            </template>
                          </template>
                        </div>
                        <button
                          class="btn-request"
                          :disabled="!!item.freezing"
                          @click="
                            selectFund(item);
                            openModalFreeze();
                          "
                        >
                          <img src="@/assets/images/app/Cursor.svg" alt="" />
                        </button>
                        <div class="freezeplan__txt">
                          <span v-if="!item.freezing">Solicitar</span>
                          <span
                            v-if="item.freezing"
                            :class="{ 'text-disabled': item.freezing }"
                            >Solicitado</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
          id="modal-login"
          ok-only
          ok-title="Entendido"
          centered
          modal-class="modal-login"
          ref="modal-endorsement"
      >
        <form class="modal-login__modidyAport">
          <div class="modal-login__txt" v-if="selectedFund.policyId !== ''">
            <p>
              ¿Estás segur@ que deseas solicitar el cambio <br />
              de tu aporte mensual de S/{{ selectedFund.paymentAmount }} a S/{{
                selectedFund.changeAmountSlider.amount
              }}?
            </p>
            <span
            >Se aplica 15 días de tiempo de respuesta a partir de la fecha de
              solicitud. Tu próxima modificación la podrás realizar después de 6
              meses.</span
            >
          </div>
          <div class="modal-login__buttons">
            <button
                type="button"
                class="cancel"
                @click="closeModal('modal-endorsement')"
            >
              Cancelar
            </button>
            <button
                type="button"
                class="accept"
                :disabled="endorsment"
                @click="changePolicyAmount()"
            >
              <span v-if="!endorsment">Aceptar</span>
              <span v-if="endorsment"
              ><i class="fas fa-circle-notch fa-spin"></i
              ></span>
            </button>
          </div>
        </form>
      </b-modal>

      <b-modal
          id="modal-ZoneC"
          ok-only
          ok-title="Entendido"
          centered
          modal-class="modal-ZoneC"
          ref="modal-freeze"
      >
        <form class="modal-ZoneC__freezeplan">
          <div class="modal-ZoneC__txt">
            <p>
              ¿Estás segur@ que deseas solicitar el <br />
              congelamiento de tu plan?
            </p>
            <span
            >Se aplica 15 días de tiempo de respuesta a partir de la fecha de
              solicitud. Tu plan será congelado por un mes.</span
            >
          </div>
          <div class="modal-ZoneC__btn">
            <button
                type="button"
                class="cancel"
                :disabled="freezing"
                @click="closeModal('modal-freeze')"
            >
              Cancelar
            </button>
            <button
                type="button"
                class="accept"
                :disabled="freezing"
                @click="freezePolicy()"
            >
              <span v-if="!freezing">Aceptar</span>
              <span v-if="freezing"
              ><i class="fas fa-circle-notch fa-spin"></i
              ></span>
            </button>
          </div>
        </form>
      </b-modal>
    </div>
    <div class="d-none">
      <!--===========================-->

      <div class="rumbo-layout">
        <div class="rumbo-layout__header">
          <h1>Mis fondos</h1>
          <a
              :href="basePath + '/seguro-de-vida/rumbo/client-zone/new-plan'"
              class="btn"
          >+ Crear un nuevo fondo</a
          >
        </div>
        <div class="rumbo-layout__section" v-if="funds.length > 0">
          <div
              class="card"
              v-for="item in funds"
              v-bind:key="item.policyId"
              :class="{ collapsed: item.collapsed }"
          >
            <div class="card-header">
              <span>
                {{ item.friendlyName }}
                <small v-if="item.freezed"
                >Tu plan está congelado.Para descongelar tu plan comunícate a
                  nuestro whatsapp o correo</small
                >
              </span>
              <div class="summary" v-if="item.collapsed">
                <span>Próximo pago: {{ item.nextPaymentDateFormatted }}</span>
                <div class="progress">
                  <div
                      class="progress-bar"
                      role="progressbar"
                      v-bind:style="{ width: item.pieChart.series[0] + '%' }"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                  ></div>
                </div>
                <span>{{ item.pieChart.series[0] }}%</span>
              </div>
              <a role="button" @click="toggleItem(item)">
                <img
                    :src="require('@/assets/images/app/angle-down-purple.svg')"
                    alt=""
                />
              </a>
            </div>
            <div class="card-body" v-if="!item.collapsed">
              <div class="fund">
                <div class="row">
                  <div class="col-md-8 col-12">
                    <div class="row">
                      <div class="col-md-6 col-12 hidden-mobile">
                        <div class="fund__section">
                          <h3 class="fund__section__title">
                            Aporte&nbsp;
                            <template v-if="item.frequency === 1">
                              mensual</template
                            >
                            <template v-if="item.frequency === 3">
                              trimestral</template
                            >
                            <template v-if="item.frequency === 12">
                              anual</template
                            >
                          </h3>
                          <div class="fund__section__amount">
                            S/ {{ formatNumber(item.paymentAmount) }}
                          </div>
                          <div class="fund__section__date">
                            Tu próximo pago se realizará el
                            {{ item.nextPaymentDateFormatted }}
                          </div>
                          <button
                              class="btn btn-add-payment"
                              :disabled="item.freezed"
                              @click="
                              selectFund(item);
                              navigateToAdditionalContribution();
                            "
                          >
                            Realizar un aporte adicional
                          </button>
                          <h3 class="fund__section__title">
                            <span>Plazo para mi meta</span>
                            <span class="ml-auto text-capitalize">{{
                                item.expireOnDate
                              }}</span>
                          </h3>
                          <div class="chart">
                            <!-- <ecommerce-goal-overview :data="item.pieChart" /> -->
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-12">
                        <div class="fund__section">
                          <h3 class="fund__section__title">
                            <span>Mi fondo</span>
                          </h3>

                          <div class="expire visible-mobile">
                            <span>Plazo para mi meta:</span><br />
                            <span class="dateExpire">{{
                                item.expireOnDate
                              }}</span>
                          </div>

                          <div class="paymentAmount visible-mobile">
                            <span>Ahorro acumulado</span><br />
                            <span class="payment-amount"
                            >S/{{ formatNumber(item.totalPaid) }}</span
                            >
                          </div>

                          <div class="chart bg-white">
                            <h3 class="fund__section__subtitle hidden-mobile">
                              Mensual
                              <div class="legend">Mis ahorros</div>
                              <div class="form-group ml-auto">
                                <select name="" id="" class="form-control">
                                  <option value="2022">2022</option>
                                </select>
                              </div>
                            </h3>
                            <!-- <ecommerce-order-chart :data="item.barChart" /> -->
                          </div>
                          <div class="chart bg-white hidden-mobile">
                            <h3 class="fund__section__subtitle">
                              Acumulado
                              <div class="legend">Mis ahorros</div>
                            </h3>
                            <!-- <ecommerce-profit-chart :data="item.lineChart" /> -->
                          </div>
                          <div class="fund__section2__date visible-mobile">
                            Tu próximo pago se realizará el<br />
                            {{ item.nextPaymentDateFormatted }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12 hidden-mobile">
                    <div class="fund__section">
                      <div class="fund__actions">
                        <button
                            class="btn btn-action"
                            :disabled="item.freezed"
                            v-if="item.paidPayments.length >= 6"
                            @click="
                            selectFund(item);
                            navigateToChangeAmount();
                          "
                        >
                          <img
                              :src="require('@/assets/images/app/usd-pie.svg')"
                              alt=""
                          />
                          Modificar mis aportes
                        </button>
                        <button
                            class="btn btn-action"
                            :disabled="item.freezed"
                            @click="
                            selectFund(item);
                            navigateToAdditionalContribution();
                          "
                        >
                          <img
                              :src="require('@/assets/images/app/usd-pie.svg')"
                              alt=""
                          />
                          Hacer aporte adicional
                        </button>
                        <!-- <button
                          class="btn btn-action"
                          :disabled="item.freezed"
                          v-if="validateMinimumTime(item)"
                          @click="
                            selectFund(item);
                            openModal('modal-confirm');
                          "
                        >
                          <img
                            :src="require('@/assets/images/app/usd-pie.svg')"
                            alt=""
                          />
                          Congelar mi plan
                        </button> -->
                        <h4>¿Cambiaste de tarjeta?</h4>
                        <button
                            class="btn btn-action"
                            :disabled="item.freezed"
                            @click="
                            selectFund(item);
                            navigateToChangePaymentMethod();
                          "
                        >
                          <img
                              :src="require('@/assets/images/app/card-white.svg')"
                              alt=""
                          />
                          <span>Quiero modificar mi método de pago</span>
                        </button>
                        <template v-if="!item.debitAutomatic">
                          <h4>¿No te afiliaste al débito automático?</h4>
                          <button
                              class="btn btn-action"
                              :disabled="item.freezed"
                              @click="
                              selectFund(item);
                              navigateToSinglePayment();
                            "
                          >
                            <img
                                :src="
                                require('@/assets/images/app/card-white.svg')
                              "
                                alt=""
                            />
                            <span>Pagar mi aporte mensual</span>
                          </button>
                        </template>
                      </div>
                    </div>
                  </div>

                  <div class="visible-mobile w-100">
                    <div class="col-md-4 col-12 mt-2">
                      <div class="section-3">
                        <div class="section-3__info">
                          <div class="row">
                            <div
                                class="col"
                                v-if="item.paidPayments.length >= 3"
                            >
                              <a
                                  @click="
                                  selectFund(item);
                                  navigateToChangeAmount();
                                "
                              ><img
                                  :src="
                                    require('@/assets/images/app/usd-pie.svg')
                                  "
                                  alt=""
                              />
                                <p style="text-center">
                                  Modificar<br />mis aportes
                                </p>
                              </a>
                            </div>
                            <div class="col">
                              <a
                                  @click="
                                  selectFund(item);
                                  navigateToAdditionalContribution();
                                "
                              ><img
                                  :src="
                                    require('@/assets/images/app/usd-pie.svg')
                                  "
                                  alt=""
                              />
                                <p style="text-center">
                                  Hacer aporte<br />adicional
                                </p>
                              </a>
                            </div>
                            <div class="col" v-if="validateMinimumTime(item)">
                              <a
                                  @click="
                                  selectFund(item);
                                  openModal('modal-confirm');
                                "
                              ><img
                                  :src="
                                    require('@/assets/images/app/usd-pie.svg')
                                  "
                                  alt=""
                              />
                                <p style="text-center">Congelar<br />mi plan</p>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="visible-mobile">
                    <div class="col-md-4 col-12 mt-2">
                      <div class="section-4" style="padding: 12px">
                        <div class="section-4__info">
                          <div class="row">
                            <div
                                class="col changedCard"
                                style="padding-right: 10px"
                            >
                              <div
                                  style="justify-content: center; display: flex"
                              >
                                <img
                                    style="margin-top: 8px; margin-right: 7px"
                                    :src="
                                    require('@/assets/images/app/usd-pie.svg')
                                  "
                                    alt=""
                                />
                                <div style="width: 123px">
                                  <h6
                                      class="changed"
                                      style="margin-bottom: 0px"
                                  >
                                    ¿Cambiaste de tarjeta?
                                  </h6>
                                  <a
                                      @click="
                                      selectFund(item);
                                      navigateToChangePaymentMethod();
                                    "
                                  >
                                    <span>Cambiar metodo de pago</span></a
                                  >
                                </div>
                              </div>
                            </div>
                            <div
                                class="col additionalContribution"
                                style="padding-left: 0px; padding-right: 10px"
                                v-if="!item.debitAutomatic"
                            >
                              <div
                                  style="justify-content: center; display: flex"
                              >
                                <img
                                    style="margin-top: 8px"
                                    :src="
                                    require('@/assets/images/app/usd-pie.svg')
                                  "
                                    alt=""
                                />
                                <div style="width: 130px">
                                  <h6
                                      class="changed"
                                      style="margin-bottom: 0px"
                                  >
                                    ¿No estas en debido automatico?
                                  </h6>
                                  <a
                                      @click="
                                      selectFund(item);
                                      navigateToSinglePayment();
                                    "
                                  >
                                    <span>Pagar mi aporte mensual</span></a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="visible-mobile">
                    <div class="col-md-4 col-12 mt-2">
                      <div class="info-mobile">
                        <div class="info-mobile__section">
                          <div class="sidebar-inf">
                            <div class="sidebar-info__item">
                              <img
                                  :src="
                                  require('@/assets/images/app/shield-user.png')
                                "
                                  alt=""
                              />
                              <span
                              >Tu ahorro incluye un seguro de vida por
                                S/25,000 para proteger a los que más amas</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
          id="modal-options"
          ok-only
          ok-title="Entendido"
          centered
          size="md"
          modal-class="modal-input-options"
          title="Te presentamos las siguientes opciones:"
      >
        <div class="modal-input-options__list">
          <button class="btn btn-second" disabled>Modificar mis aportes</button>
          <button
              class="btn btn-second"
              @click="navigateToAdditionalContribution()"
          >
            Hacer aporte adicional
          </button>
          <button class="btn btn-second" disabled>Adelantar mi dinero</button>
        </div>
      </b-modal>
      <b-modal
          id="modal-confirm"
          ok-only
          ok-title="Entiendo"
          centered
          size="sm"
          modal-class="modal-confirm"
          ref="modal-confirm"
      >
        <div class="modal-confirm__body">
          <p>¿Esta seguro que desea congelar su poliza?</p>
          <div class="actions">
            <button
                :disabled="freezing"
                class="btn btn-main"
                @click="freezePolicy()"
            >
              Aceptar
            </button>
            <button
                :disabled="freezing"
                class="btn btn-outline-main"
                @click="closeModal('modal-confirm')"
            >
              Cancelar
            </button>
          </div>
        </div>
      </b-modal>

      <!--Modales-->
      <b-modal
          id="modal-error"
          ok-only
          ok-title="Entiendo"
          centered
          modal-class="modal-error"
          ref="modal-error"
      >
        <div class="modal-error__header">
          <div class="modal-error__header__message">
            <span>Error</span>
          </div>
          <div class="modal-error__img">
            <img :src="require('@/assets/images/app/error.svg')" alt="" />
          </div>
        </div>
        <div class="modal-error__head">
          <span
          >Tiene una solicitud pendiente de aprobación. Para más detalle,
            puede escribirnos a rumbo@interseguro.com.pe</span
          >
          <div class="modal-error__head__btn">
            <button
                type="button"
                class="accept"
                @click="closeModal('modal-error')"
            >
              Entendido
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
          id="modal-error"
          ok-only
          ok-title="Entiendo"
          centered
          modal-class="modal-error"
          ref="modal-same-amount"
      >
        <div class="modal-error__header">
          <div class="modal-error__header__message">
            <span>Error</span>
          </div>
          <div class="modal-error__img">
            <img :src="require('@/assets/images/app/error.svg')" alt="" />
          </div>
        </div>
        <div class="modal-error__head">
          <span
          >El monto que elijas tiene que ser diferente al de tu aporte mensual
            actual.</span
          >
          <div class="modal-error__head__btn">
            <button
                type="button"
                class="accept"
                @click="closeModal('modal-same-amount')"
            >
              Entendido
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
          id="modal-error"
          ok-only
          ok-title="Entiendo"
          centered
          modal-class="modal-error"
          ref="modal-additional-payment-error"
      >
        <div class="modal-error__header">
          <div class="modal-error__header__message">
            <span>Error</span>
          </div>
          <div class="modal-error__img">
            <img :src="require('@/assets/images/app/error.svg')" alt="" />
          </div>
        </div>
        <div class="modal-error__head">
          <span
          >Lo sentimos, has llegado al máximo de aportes adicionales.</span
          >
          <div class="modal-error__head__btn">
            <button
                type="button"
                class="accept"
                @click="closeModal('modal-additional-payment-error')"
            >
              Entendido
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
          id="modal-success"
          ok-only
          ok-title="Entiendo"
          centered
          modal-class="modal-success"
          ref="modal-success"
      >
        <div class="modal-success__header">
          <div class="modal-success__header__message">
            <span>Enviado</span>
          </div>
          <div class="modal-success__img">
            <img :src="require('@/assets/images/app/checks.svg')" alt="" />
          </div>
        </div>

        <div class="modal-success__head">
          <div class="modal-success__head__content">
            <span class="evaluate"
            >Tu solicitud de cambio de aporte mensual de S/ 400 a S/200 será
              evaluada.</span
            >
            <span class="time mt-1"
            >Se aplica 15 días de tiempo de respuesta. Próxima solicitud
              después de 6 meses.</span
            >
          </div>
          <div class="modal-success__head__btn">
            <button
                type="button"
                class="accept"
                @click="closeModal('modal-success')"
            >
              Entendido
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
          id="modal-success"
          ok-only
          ok-title="Entiendo"
          centered
          modal-class="modal-success"
          ref="modal-freeze-success"
      >
        <div class="modal-success__header">
          <div class="modal-success__header__message">
            <span>Enviado</span>
          </div>
          <div class="modal-success__img">
            <img :src="require('@/assets/images/app/checks.svg')" alt="" />
          </div>
        </div>

        <div class="modal-success__head">
          <div class="modal-success__head__content">
            <span class="evaluate"
            >Tu solicitud de congelamiento será evaluada.</span
            >
            <span class="time"
            >Se aplica 15 días de tiempo de respuesta. Próxima solicitud
              después de 6 meses.</span
            >
          </div>
          <div class="modal-success__head__btn">
            <button
                type="button"
                class="accept"
                @click="closeModal('modal-freeze-success')"
            >
              Entendido
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<!-- <script lang="ts"> -->
<script>
import { BModal } from "bootstrap-vue";

import { BRow, BCol } from "bootstrap-vue";
import axios from "axios";
import * as moment from "moment";
import "moment/locale/es";
import { environment } from "../../environment/environment";
import slider from "vue3-slider";
import PaymentsChart from "./../../components/PaymentsChart.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    BRow,
    BCol,
    PaymentsChart,
    BModal,
    "vue3-slider": slider,
  },
  data() {
    return {
      basePath: window["basePath"],
      apiUrl: environment.api,
      isApiNewBack: environment.isApi,
      data: {},
      funds: [],
      selectedFund: {
        policyId: "",
      },
      error: "",
      amountSlider: {
        min: 160,
        max: 700,
        interval: 20,
      },
      additionalPayment: 160,
      newPaymentAmount: 160,
      awesome: false,
      freezing: false,
      endorsment: false,
      loading: false,
      consTrack: {
        AplicacionEndoso: "A",
        SolicitudEndoso: "S",
        AdminRumbo: "ADM",
        ZonaCliente: "CLI",
        EndosoSimple: "ED",
        EndosoComplejo: "EC",
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadFunds();
      moment.locale("es");
    },
    showUserName() {
      let user = window.localStorage.getItem("__user__");
      if (user) {
        user = JSON.parse(user);

        return user.firstName;
      }

      return "";
    },
    async loadFunds() {
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      this.loading = true;

      let result = await axios.get(`${this.apiUrl}policies`, headers);

      if (result.data) {
        let funds = [];
        if (result.data.length > 0) {
          funds = result.data.map((el) => {
            let payments = el.payments.sort(function (a, b) {
              if (new Date(a.transactionDate) > new Date(b.transactionDate)) {
                return 1;
              }
              if (new Date(a.transactionDate) < new Date(b.transactionDate)) {
                return -1;
              }
              return 0;
            });

            let paidPayments = el.payments.filter((payment) => {
              return payment.paymentStatus === 1 && payment.quote > 0;
            });

            let paidInstallments = payments.filter((el, i) => {
              el.monthId = moment(el.transactionDate).format("MM-YYYY");
              return el.paymentStatus === 1;
            });

            let totalPaid = 0;
            let groupedData = {};
            paidInstallments.forEach((el) => {
              if (groupedData[el.monthId]) {
                groupedData[el.monthId].payments.push(el);
              } else {
                groupedData[el.monthId] = {
                  monthName: moment(el.transactionDate)
                      .format("MMM")
                      .toUpperCase()
                      .replace(".", ""),
                  payments: [el],
                };
              }

              totalPaid += el.amount;
            });

            let groupedDataArray = [];
            for (let key in groupedData) {
              groupedDataArray.push({
                key,
                ...groupedData[key],
              });
            }

            let rest =
                5 * Math.ceil(groupedDataArray.length / 5) -
                groupedDataArray.length;
            let _grouped = [...groupedDataArray];
            let lastMonth = {
              ..._grouped.reverse()[0],
            };
            let lastMonthDate = moment(lastMonth.payments[0].transactionDate);

            for (let i = 0; i < rest; i++) {
              lastMonthDate = lastMonthDate.add(1, "months");
              groupedDataArray.push({
                key: lastMonthDate.format("MM-YYYY"),
                monthName: lastMonthDate
                    .format("MMM")
                    .toUpperCase()
                    .replace(".", ""),
                payments: [
                  {
                    amount: 0,
                    transactionDate: lastMonthDate.toDate()
                  },
                ],
              });
            }

            groupedDataArray = groupedDataArray.map((el) => {
              let total = 0;
              el.payments.forEach((p) => {
                total += p.amount;
              });

              el.totalAmount = total;

              return el;
            });

            let amounts = groupedDataArray.map((el) => el.totalAmount);
            let minY = Math.min(...amounts);
            let maxY = Math.max(...amounts);

            var ranges = [];
            let groups = groupedDataArray.length / 5;
            for (let i = 0; i < groups; i++) {
              ranges.push([]);
              for (let j = 0; j < 5; j++) {
                ranges[i].push(groupedDataArray[i * 5 + j]);
              }
            }

            // ranges.reverse();

            let progress = [Math.round((totalPaid / el.amount) * 100)];
            let pieChart = {
              series: progress,
              label: totalPaid,
              total: el.amount,
            };

            let barSeries = [
              {
                name: "Aporte Mensual",
                data: ranges[ranges.length - 1].map((el) => {
                  let total = 0;
                  el.payments.forEach((p) => {
                    total += p.amount;
                  });
                  return total;
                }),
              },
            ];
            let barLabels = ranges[ranges.length - 1].map((el) => {
              let paymentDate = new Date(el.payments[0].transactionDate);
              let monthName = el.monthName;
              if (paymentDate.getDate() === 1) {
                monthName = el.monthName;
              } else {
                monthName = moment(paymentDate)
                    .add(1, "months")
                    .format("MMM")
                    .toUpperCase()
                    .replace(".", "");
              }

              return monthName;
            });
            let barChart = {
              series: barSeries,
              labels: barLabels,
              minY: minY,
              maxY: maxY,
            };

            let accumulated = 0;
            let lineSeries = [
              {
                name: "Acumulado Mensual",
                data: groupedDataArray.map((el) => {
                  let total = 0;
                  el.payments.forEach((p) => {
                    total += p.amount;
                  });
                  accumulated += total;
                  return accumulated;
                }),
              },
            ];
            let lineLabels = groupedDataArray.map((el) => {
              return el.monthName;
            });
            let lineChart = {
              series: lineSeries,
              labels: lineLabels,
            };
            let expireOnDate = moment(el.expiresOn).format("MMMM YYYY");
            let nextPaymentDate = moment(el.nextPaymentDate).add(1, "months");
            let nextPaymentDateFormatted =
                nextPaymentDate.format("[1 de] MMMM YYYY");
            let allowMonthlyPayment = true;

            let now = new Date();
            nextPaymentDate = moment(
                nextPaymentDate.format("MM/[1]/YYYY")
            ).toDate();

            if (now < new Date(el.nextPaymentDate)) {
              allowMonthlyPayment = false;
            }

            let completedPayments = new Date(el.nextPaymentDate) > new Date();

            let minAmount = el.paymentAmount / 2;

            if (minAmount < 160) {
              minAmount = 160;
            }

            let amountSlider = {
              min: 160,
              max: el.paymentAmount,
              interval: 10,
              amount: el.paymentAmount,
            };

            let max = el.paymentAmount * 2;
            max = max > 700 ? 700 : max;

            if (el.periodicity === 4) {
              max = el.paymentAmount;
            }

            let changeAmountSlider = {
              min: minAmount,
              max: max,
              interval: 10,
              amount: minAmount,
            };

            let collapsed = true;

            if (this.$route.query && this.$route.query.open) {
              if (this.$route.query.open === el.policyId) {
                collapsed = false;
              }
            }

            if (this.selectedFund) {
              if (this.selectedFund.policyId === el.policyId) {
                collapsed = false;
              }
            }

            var startDate = moment(el.policyDate).format("DD/MM/YYYY");

            var endDate = moment(el.expiresOn).format("DD/MM/YYYY");

            return {
              nextPaymentDateFormatted: moment(el.nextPaymentDate)
                  .add(1, "months")
                  .format("[01]/MM/YYYY"),
              pieChart,
              nextPaymentStartDateFormatted: moment(el.nextPaymentDate).format(
                  "[21]/MM/YYYY"
              ),
              selectedGroup: ranges.length,
              ranges,
              pieChart,
              barChart,
              lineChart,
              expireOnDate,
              totalPaid,
              collapsed: collapsed,
              ...el,
              paidPayments,
              startDate,
              endDate,
              amountSlider,
              changeAmountSlider,
              completedPayments,
              minY: minY,
              maxY: maxY,
            };
          });

          this.funds = funds;

          this.loading = false;
        }
      }
    },
    nextGroup(item) {
      if (item.selectedGroup === item.ranges.length) return;

      item.barChart = null;

      item.selectedGroup++;

      let barSeries = [
        {
          name: "Aporte Mensual",
          data: item.ranges[item.selectedGroup - 1].map((el) => {
            let total = 0;
            el.payments.forEach((p) => {
              total += p.amount;
            });
            return total;
          }),
        },
      ];
      let barLabels = item.ranges[item.selectedGroup - 1].map((el) => {
        let paymentDate = new Date(el.payments[0].transactionDate);
        let monthName = el.monthName;
        if (paymentDate.getDate() === 1) {
          monthName = el.monthName;
        } else {
          monthName = moment(paymentDate)
              .add(1, "months")
              .format("MMM")
              .toUpperCase()
              .replace(".", "");
        }

        return monthName;
      });

      let barChart = {
        series: barSeries,
        labels: barLabels,
        minY: item.minY,
        maxY: item.maxY,
      };

      setTimeout(() => {
        item.barChart = barChart;
      }, 500);
    },
    previousGroup(item) {
      if (item.selectedGroup === 1) return;
      item.barChart = null;

      item.selectedGroup--;

      let barSeries = [
        {
          name: "Aporte Mensual",
          data: item.ranges[item.selectedGroup - 1].map((el) => {
            let total = 0;
            el.payments.forEach((p) => {
              total += p.amount;
            });
            return total;
          }),
        },
      ];
      let barLabels = item.ranges[item.selectedGroup - 1].map((el) => {
        let paymentDate = new Date(el.payments[0].transactionDate);
        let monthName = el.monthName;
        if (paymentDate.getDate() === 1) {
          monthName = el.monthName;
        } else {
          monthName = moment(paymentDate)
              .add(1, "months")
              .format("MMM")
              .toUpperCase()
              .replace(".", "");
        }

        return monthName;
      });

      let barChart = {
        series: barSeries,
        labels: barLabels,
        minY: item.minY,
        maxY: item.maxY,
      };

      setTimeout(() => {
        item.barChart = barChart;
      }, 100);
    },
    getEmptyMonths(item) {
      let series = item.barChart.series[0].data;
      let emptyMonths = series.filter((el) => el === 0);

      return emptyMonths.length;
    },
    validateMinimumTime(item) {
      var diff = moment(new Date()).diff(
          moment(item.createdOn),
          "months",
          true
      );
      return diff >= 3;
    },
    toggleItem(item) {
      item.collapsed = !item.collapsed;
    },
    selectFund(fund) {
      this.selectedFund = fund;
      console.log("selectedFund", this.selectedFund )
      window.localStorage.setItem("__selectedFund__", JSON.stringify(fund));
    },
    newPlan() {
      this.$router.push({
        name: "newplan",
      });
    },
    navigateToAdditionalContribution() {
      if (this.selectedFund.additionalPaymentsNumber >= 2) {
        this.$refs["modal-additional-payment-error"].show();
        return;
      }

      window.localStorage.setItem(
          "__additionalAmount__",
          this.selectedFund.amountSlider.amount
      );
      this.$router.push({
        name: "additionalcontribution",
        params: { id: this.selectedFund.policyId },
      });
    },
    navigateToChangeAmount() {
      window.localStorage.setItem(
          "__newAmount__",
          this.selectedFund.changeAmountSlider.amount
      );

      this.$router.push({
        name: "additionalcontribution",
        params: { id: this.selectedFund.policyId },
      });
    },
    navigateToChangePaymentMethod() {
      this.$router.push({
        name: "changepaymentmethod",
        params: { id: this.selectedFund.policyId },
      });
    },
    navigateToSinglePayment() {
      this.$router.push({
        name: "singlepayment",
        params: { id: this.selectedFund.policyId },
      });
    },
    formatNumber(number) {
      return number.toLocaleString("en-US");
    },
    async freezePolicy() {
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let expiracion = this.selectedFund.expiresOn
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      try {
        this.freezing = true;
        let model = {
          id: this.selectedFund.policyId,
        };
        let result = await axios.post(
            `${this.apiUrl}policies/${this.selectedFund.policyId}/freeze`,
            model,
            headers
        );

        if (result.data !== undefined) {
          this.trackingReport(this.consTrack.SolicitudEndoso, this.consTrack.ZonaCliente, this.consTrack.EndosoSimple, "Congelamiento/Diferimiento", "", "", 1, expiracion, "")
          this.freezing = false;
          this.$refs["modal-freeze"].hide();
          this.$refs["modal-freeze-success"].show();

          this.loadFunds();
        }
      } catch (error) {
        this.freezing = false;
        this.error = error.response.data.detail;
        this.$refs["modal-freeze"].hide();
        this.$refs["modal-error"].show();
      }
    },
    async changePolicyAmount() {
      window.localStorage.removeItem("__culquiToken__");
      let _context = this;

      this.endorsment = true;
      let monto =  this.policy.paymentAmount;
      let model = {
        id: this.selectedFund.policyId,
        amount: this.selectedFund.changeAmountSlider.amount,
      };

      try {
        let auth = JSON.parse(window.localStorage.getItem("__auth__"));
        let headers = {
          headers: {
            Authorization: auth.token_type + " " + auth.access_token,
          },
        };
        var result = await axios.post(
            `${_context.apiUrl}policies/${this.selectedFund.policyId}/additionalContributions/endorsement`,
            model,
            headers
        );

        if (result.data) {
          if (this.selectedFund.changeAmountSlider.amount < this.selectedFund.paymentAmount) {
            this.trackingReport(this.consTrack.SolicitudEndoso, this.consTrack.ZonaCliente, this.consTrack.EndosoComplejo, "Disminución de prima", monto, "", "", "")
          } else if (this.selectedFund.changeAmountSlider.amount > this.selectedFund.paymentAmount) {
            this.trackingReport(this.consTrack.SolicitudEndoso, this.consTrack.ZonaCliente, this.consTrack.EndosoComplejo, "Incremento de prima", monto, "", "", "")
          }
        }

        this.endorsment = false;
        this.$refs["modal-endorsement"].hide();
        this.$refs["modal-success"].show();

        this.loadFunds();
      } catch (error) {
        this.$refs["modal-endorsement"].hide();
        this.$refs["modal-error"].show();
        this.error = error.response.data.detail;
        this.endorsment = false;
      }
    },
    async trackingReport(operacion, canal, tipo, detalle, nueva_prima, monto_aporte_adicional, meses_congelados, fecha_congelamiento, nuevo_correo) {
      let url = `${this.isApiNewBack}v1/legacy/report/tracking`;
      let model = {
        operacion: operacion,
        canal: canal,
        tipo: tipo,
        detalle: detalle,
        numero_poliza: this.selectedFund.referencePolicyNumber,
        nueva_prima: nueva_prima,
        monto_aporte_adicional: monto_aporte_adicional,
        meses_congelados: meses_congelados,
        fecha_congelamiento: fecha_congelamiento,
        nuevo_correo: nuevo_correo
      };

      try {
        let result = await axios.post(url, model);
        if (result.data !== undefined) {
          console.log(result.data)
        }
      } catch (error) {
        console.log(error)
      }
    },
    openModalEndorsement(modal) {
      if (this.selectedFund.endorsement || this.selectedFund.freezing) return;

      if (
          this.selectedFund.changeAmountSlider.amount ===
          this.selectedFund.paymentAmount
      ) {
        this.$refs["modal-endorsement"].hide();
        this.$refs["modal-same-amount"].show();
        return;
      }

      this.$refs[modal].show();
    },
    openModalFreeze() {
      if (this.selectedFund.endorsement || this.selectedFund.freezing) return;

      this.$refs["modal-freeze"].show();
    },
    openModal(modal) {
      this.$refs[modal].show();
    },
    closeModal(modal) {
      this.$refs[modal].hide();
    },
    formatDate(date) {
      if (!date) return "";

      return moment(date).format("DD/MM/YYYY");
    },
    changeAmount(value, item, prop) {
      item[prop].amount = value;
    },
  },
});
</script>

<style lang="scss">
//   @import "@core/scss/vue/pages/dashboard-ecommerce.scss";
//   @import "@core/scss/vue/libs/chart-apex.scss";
@import "./../../styles/abstracts/variables";

/**DESKTOP */
.hidden-mobile {
  @media (max-width: 479px) {
    display: none;
  }
}

/**MOBILE */
.visible-mobile {
  display: none;

  @media (max-width: 479px) {
    display: block;
  }
}

/**IMG-DESKTOP */
.img-desktop {
  @media (max-width: 479px) {
    display: none;
  }
}

/**IMG-MOBILE */
.img-mobile {
  display: none;

  @media (max-width: 479px) {
    display: block;
  }
}

/*====================================================*/
.section-plan {
  .rumbo-layout {
    &__header {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      margin-top: 20px;

      .fa-plus {
        margin-right: 8px;
      }
    }

    a {
      width: 250px;
      height: 31px;
      background-color: $mainColor;
      color: #fff;
      border-radius: 5px;
      margin-left: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 20px;
      padding: 0;
    }

    span {
      color: #707070;
      font-size: 25px;
      margin-left: 25px;
      font-weight: 500;
      word-spacing: 5px;
      margin-right: 14px;
    }
  }
}

/**CHANGE-CARD */
.changecard {
  .card {
    border: none;

    .card-body {
      border-radius: 25px;
      box-shadow: 0px 3px 6px #00000029 !important;

      @media screen and (min-width: 1170px) {
        &.card-body {
          width: 353px !important;
          margin-left: 66px !important;
        }
      }
    }
  }

  &__content {
    display: flex;

    .description {
      &__title-pink {
        color: #ea0b90;
        font-size: 15px;
        font-weight: 500;
      }

      &__subtitle {
        color: #707070;
        font-size: 15px;
      }
    }

    .credit-card {
      margin-right: 20px;
    }

    .action {
      margin-left: auto;
      cursor: pointer;
    }
  }
}

/**OPTION */
.option {
  .card {
    border: none;

    .card-body {
      border-radius: 25px;
      box-shadow: 0px 3px 6px #00000029 !important;
    }
  }

  &__content {
    display: flex;
    color: #707070;
    font-size: 10px;

    .description {
      &__title {
        color: #707070;
        font-size: 15px;
      }

      &__subtitle {
        color: #707070;
        font-size: 15px;
        line-height: 15px;
      }

      &__content {
        color: #707070;
        font-size: 12px;
        margin-top: 4px;
      }
    }

    .icon {
      margin-right: 20px;
    }

    .action {
      margin-left: auto;
      cursor: pointer;
    }
  }
}

/**MYPLAN */
.myplan {
  .asd {
    position: relative;
    // width: 995px;
    // height: 107px;
    border-radius: 25px;
    background-color: #ffffff;
    margin-bottom: 30px;
    border: none;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);

    @media screen and (min-width: 1170px) {
      &.asd {
        width: 995px !important;
      }
    }
  }

  &__zone-client {
    width: 995px;
    height: 107px;
  }

  &__plan {
    text-align: center;
    margin-left: -18px;

    .col-status {
      margin-right: -110px;
      white-space: nowrap;

      p {
        margin-bottom: 5px;
        font-size: 22px;
        height: 18px;
        margin: 8px 0px 0px 0;
        display: flex;
        justify-content: center;
        width: 105px;
        text-align: center;

        &.freezed {
          color: #ea0b90;
        }
      }

      span {
        width: 105px;
        text-align: center;
        display: block;
      }
    }

    .row {
      .col-4 {
        @media (min-width: $desktopBreak) {
          margin-left: 40px !important;
        }
      }
    }

    h6 {
      font-size: 25px;
      font-weight: 600;
      color: #0855c4;
      margin-bottom: 0;
    }

    p {
      font-size: 18px;
      color: #15ce75;
      line-height: 10px;
      // margin-left: 12px;
      margin-bottom: 0;
      font-weight: 500;
    }

    span {
      color: #5d5d5d;
      font-size: 15px;
    }
  }

  &__month {
    text-align: center;
    margin-right: -24px;
    //margin-left: -25px;

    p {
      color: #707070;
      font-size: 14px;
      font-weight: 500;
      margin: 0;
    }

    &__content {
      p {
        width: 85px;
        height: 17px;
        background-color: #0855c4;
        color: #ffffff;
        background-size: 18px;
        text-align: center;
        font-size: 13px;
        border-radius: 5px;
        font-weight: 400;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    h1 {
      font-size: 30px;
      font-weight: bold;
      color: #0855c4;
      line-height: 24px;
      margin-bottom: 8px;
    }
  }

  &__date {
    margin-left: 3px;
    font-size: 15px;
    color: #5d5d5d;
    font-weight: 400;

    &__content {
      position: absolute;
      top: 17px;
      right: -75px;

      &.open {
        button::before {
          // top: -56px;
          transform: rotate(135deg);
        }
      }
    }

    button {
      border: none;
      background-color: transparent !important;

      &::before {
        content: "";
        position: absolute;
        width: 19px;
        height: 18px;
        border: 4px solid $green;
        border-top: none;
        border-right: none;
        transform: rotate(-45deg);

        @media screen and (max-width: $mobileBreak) {
          margin-left: 10px;
          margin-top: 20px;
          right: 128px;
          width: 16px;
          height: 16px;
        }

        // @media screen and (max-width: 390px) {
        //     right: 115px;
        // }

        // @media screen and (max-width: 844px) {
        //     right: 121px;
        // }

        // @media screen and (max-width: 390px) {
        //     right: 114px;
        // }
      }
    }

    &__date-pay {
      margin-left: -19px;
      position: relative;

      .status {
        color: #15ce75;
        font-size: 18px;
        position: absolute;
        margin-bottom: 0 !important;
        display: flex;
        align-items: center;
        width: 123px;
        justify-content: center;
      }
    }

    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      button {
        position: absolute;
        right: 10px;
        top: 20%;
        justify-content: center;
        align-items: center;
        text-align: center;
        border: none;
        outline: none;
        background-color: #000;
      }
    }

    span {
      word-spacing: 3px;
    }

    span:nth-child(1) {
      width: 50px;
      display: block;
    }

    .iconZone {
      color: #15ce75;
      display: none;
    }
  }
}

/**PAY */
.pay {
  &__title {
    span {
      color: #0855c4;
      font-size: 18px;
      font-weight: 600;
      margin-left: 50px;
      margin-bottom: 30px;
    }

    hr {
      border-top: 2px solid #ebe9f1;
    }
  }

  .details {
    display: flex;
    justify-content: space-between;

    .money {
      height: 43px;
    }

    .title {
      .info {
        margin: auto;
        text-align: center;
        align-items: center;
        background-color: #e9fcff;
        width: 114px;
        height: 55px;

        &__txt {
          color: #0855c4;
          font-size: 12px;
          font-weight: 500;
          padding-top: 6px;
        }

        &__subtitle {
          color: #0855c4;
          font-size: 20px;
          font-weight: 900;
        }
      }

      &__content {
        text-align: center;
        color: #707070;
        font-size: 12px;
        font-weight: 400;
      }
    }

    .action {
      display: flex;
      padding-top: 20px;
      cursor: pointer;

      a {
        &.disabled {
          cursor: not-allowed;

          img {
            filter: grayscale(1);
          }
        }
      }

      .left {
        transform: rotate(180deg);
        margin-right: 18px;
      }
    }
  }

  &__charts {
    width: 393px;
    background-color: #ffffff;
    border-radius: 25px;
    padding: 28px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    margin-top: 14px;

    .chart {
      .infoAport {
        display: flex;
        justify-content: space-between;
        position: relative;
        top: -18px;

        span {
          font-size: 10px;
          color: #0855c4;
          margin-left: 80px;
          line-height: 10px;

          &.transparent {
            color: transparent !important;
          }
        }

        span:last-child {
          margin-right: 40px;
        }
      }
    }
  }
}

/**MODIFICAR'APORTE */
.modifyaport {
  .card {
    border-radius: 25px;
    border: none;
    box-shadow: 0px 3px 6px #00000029 !important;
    margin-top: 14px;

    @media screen and (min-width: 1170px) {
      &.card {
        width: 600px !important;
        margin-left: 66px !important;
      }
    }
  }

  &__content {
    display: flex;
    align-items: center;

    .title {
      margin-left: 18px;
      margin-right: auto;
    }

    i {
      position: absolute;
      margin-left: 83%;
      color: #0855c4;
      font-weight: 600 !important;
      top: 30px;
    }

    span {
      color: #707070;
      font-size: 15px;
      display: block;
    }

    span:last-child {
      color: #15ce75;
      font-size: 10px;
    }

    span:nth-child(2) {
      color: #15ce75 !important;
      font-size: 10px !important;
    }

    button {
      width: 50px !important;
      height: 35px !important;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 15px;
      background-color: #ffffff;
      border: none !important;
      outline: none !important;
    }
  }

  &__txt {
    span {
      color: #0855c4 !important;
      position: absolute;
      margin-top: 22px;
      margin-left: -42px;
    }
  }

  .requested {
    .text-disabled {
      color: #707070 !important;
    }

    button {
      cursor: not-allowed;

      img {
        filter: grayscale(1);
      }
    }

    .modifyaport__slider {
      margin-left: 26px;
    }

    .amount-selector {
      .vue3-slider {
        filter: grayscale(1);
      }
    }

    img {
      filter: grayscale(1);
    }
  }

  .modifyaport__txt {
    span {
      color: #707070 !important;
    }
  }
}

/**FREEZED PLAN */
.freezeplan {
  .card {
    width: 100%;
    border-radius: 25px;
    height: 96px;
    box-shadow: 0px 3px 6px #00000029 !important;
    border: none;
    margin-top: 30px;
  }

  &__content {
    display: flex;
    align-items: center;

    .title {
      margin-left: 18px;
      margin-right: auto;
    }

    i {
      position: absolute;
      margin-left: 83%;
      color: #0855c4;
      font-weight: 600 !important;
      top: 30px;
    }

    span {
      color: #707070;
      font-size: 15px;
      display: block;
    }

    span:nth-child(2) {
      color: #15ce75 !important;
      font-size: 10px !important;
    }

    span:last-child {
      color: #15ce75;
      font-size: 10px;
    }

    button {
      width: 50px !important;
      height: 35px !important;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 15px;
      background-color: #ffffff;
      border: none !important;
      outline: none !important;
    }
  }

  &__txt {
    span {
      color: #0855c4 !important;
      position: absolute;
      margin-top: 22px;
      margin-left: -42px;
      width: 50px !important;
      height: 35px !important;
    }
  }

  .requested {
    .freezeplan__txt {
      span {
        color: #707070 !important;
      }
    }
  }
}

/**MEDIA-PARA-MOBILE */
@media (max-width: 479px) {
  .programSavings {
    padding: 25px 0px 0px 0px !important;
    //margin: 0px !important;
    border-radius: 25px;
    background-color: white;

    .yearSaving {
      padding: 0px 25px 0px 25px;
    }

    .card {
      &.card-plan {
        &.visible-mobile {
          padding: 0px 0px 5px 0px;
          border-radius: 0px !important;
        }
      }
    }
  }

  .ahorroMes {
    padding: 0px 25px 0px 25px;
  }
}

.finalstep {
  .row {
    .stepthree {
      span {
        font-size: 20px;
        color: #0855c4;
        margin-bottom: 15px;
      }
    }

    .col-md-12 {
      .row {
        display: flex;

        .col-md-6 {
          margin-left: auto !important;
          margin-right: auto !important;
        }

        .col-md-5 {
          margin-left: auto !important;
          margin-right: auto !important;
        }
      }
    }
  }
}

.card {
  &__title {
    padding-top: 30px;

    span {
      font-size: 14px;
    }
  }
}

.modal-login {
  .btncustom {
    &__form {
      .custom-control-label:checked ~ .custom-control-label::before {
        background-color: #7367f0 !important;
        border-color: #7367f0 !important;
      }

      .custom-control-label:checked ~ .custom-control-label::after {
        background-color: #7367f0 !important;
        border-color: #7367f0 !important;
      }
    }
  }
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #00aded;
  border-color: #00aded;
  border-radius: 50%;

  @media (max-width: 479px) {
    background-color: #00aded;
    border-color: #00aded;
  }
}

.Myplan {
  .card-plan {
    border-radius: 20px;
  }

  &.a-side {
    padding: 0 !important;
    margin-right: 20px;
  }

  .card-body {
    padding-top: 6px !important;
    padding-bottom: 13px !important;
  }
}

.additionalaport {
  .card {
    border: none;

    .card-body {
      border-radius: 25px;
      box-shadow: 0px 3px 6px #00000029 !important;

      @media screen and (min-width: 1170px) {
        &.card-body {
          width: 353px !important;
          margin-left: 66px !important;
        }
      }
    }
  }

  &__content {
    display: flex;

    .description {
      &__title {
        color: #707070;
        font-size: 15px;
      }

      &__txt {
        font-size: 10px;
        color: #15ce75;
        font-weight: 500;
      }
    }

    .save {
      margin-right: 20px;
    }

    .action {
      margin-left: auto;
      cursor: pointer;
    }
  }

  &__slider {
    padding-left: 67px;

    .amount-selector {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 190px;
      // margin-top: 34px;

      .vue3-slider {
        .tooltip {
          top: -28px !important;
          background-color: transparent !important;
        }
      }

      span {
        font-size: 18px;
        color: #7b7c9a !important;
        position: relative;
      }

      .min {
        margin-left: 0 !important;
        color: #707070 !important;
        font-size: 11px !important;
      }

      .vue-slider-rail {
        height: 6px;
        color: #c8c8c8;
        border-radius: 10px;
      }

      input {
        width: 100%;
      }

      .vue-slider {
        padding: 0 !important;
      }

      .vue-slider-dot-handle {
        border: 8px solid #6a98db;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        margin-top: 4px;
      }

      //   .vue-slider
      //     .vue-slider-dot
      //     .vue-slider-dot-tooltip
      //     .vue-slider-dot-tooltip-inner
      //     .vue-slider-dot-tooltip-text {
      //     font-size: 12px;
      //     color: #0855c4 !important;
      //     font-weight: 900 !important;
      //     margin-right: 12px !important;
      //   }

      //   .vue-slider
      //     .vue-slider-dot
      //     .vue-slider-dot-tooltip
      //     .vue-slider-dot-tooltip-inner
      //     .vue-slider-dot-tooltip-text {
      //     top: 16px;
      //   }

      .vue-slider-dot-tooltip-inner {
        border-color: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
        font-weight: 500;
      }

      .vue-slider-process {
        border-radius: 10px;
      }

      .additionalaport {
        .amount-selector {
          margin-left: 66px !important;
        }
      }
    }
  }
}

/**MODALES */
.modal-login {
  justify-content: center !important;

  &__txt {
    p {
      color: #0855c4;
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 0;
      line-height: 20px;
      text-align: center;
      padding-bottom: 12px;
    }

    span {
      color: #707070;
      font-size: 14px;
      line-height: 17px;
      display: flex;
      text-align: center;
    }
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .cancel {
      background-color: #707070;
      color: #ffffff;
      width: 130px;
      height: 30px;
      font-size: 18px;
      border: none;
      outline: none;
      border-radius: 5px;
      margin-left: 32px;
    }

    .accept {
      background-color: #0855c4;
      color: #ffffff;
      width: 130px;
      height: 30px;
      font-size: 18px;
      border: none;
      outline: none;
      border-radius: 5px;
      margin-right: 32px;
    }
  }

  .modal-dialog {
    .modal-content {
      .modal-header {
        background-color: #ffffff !important;
      }
    }
  }

  .modal {
    .modal-dialog {
      .modal-content {
        width: 520px !important;
        height: 200px;
      }
    }
  }

  .modal-content {
    border-radius: 25px !important;

    .modal-header {
      display: none !important;
    }

    .modal-footer {
      display: none !important;
    }
  }
}

.modal-ZoneC {
  justify-content: center !important;

  &__txt {
    p {
      color: #0855c4;
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 0;
      line-height: 20px;
      text-align: center;
      padding-bottom: 12px;
    }

    span {
      color: #707070;
      font-size: 14px;
      line-height: 17px;
      display: flex;
      text-align: center;
    }
  }

  &__btn {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .cancel {
      background-color: #707070;
      color: #ffffff;
      width: 130px;
      height: 30px;
      font-size: 18px;
      border: none;
      outline: none;
      border-radius: 5px;
      margin-left: 32px;
    }

    .accept {
      background-color: #0855c4;
      color: #ffffff;
      width: 130px;
      height: 30px;
      font-size: 18px;
      border: none;
      outline: none;
      border-radius: 5px;
      margin-right: 32px;
    }
  }

  .modal-dialog {
    .modal-content {
      .modal-header {
        background-color: #ffffff !important;
      }
    }
  }

  .modal-content {
    .modal-body {
      padding: 30px !important;
    }
  }

  .modal {
    .modal-dialog {
      .modal-content {
        width: 520px !important;
        height: 200px;
      }
    }
  }

  .modal-content {
    border-radius: 25px !important;

    .modal-header {
      display: none !important;
    }

    .modal-footer {
      display: none !important;
    }
  }
}

/*ZONE_CLIENT*/
@media (max-width: 479px) {
  .rumbo-layout {
    .rumbo-layout {
      &__header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        a {
          width: 162px;
          height: 17px;
          background-color: $mainColor;
          color: #fff;
          border-radius: 5px;
          margin-left: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400;
          font-size: 13px;
          padding: 0;
        }

        span {
          color: #707070;
          font-size: 15px;
          margin-left: 20px;
          font-weight: 500;
          word-spacing: 5px;
          margin-right: 14px;
        }

        .fa-plus {
          color: #fff;
          padding: auto;
        }
      }
    }
  }

  .section-plan {
    &__greeting {
      span {
        color: #707070;
        font-size: 16px;
        margin-left: 25px;
        font-weight: 500;
      }
    }
  }

  .new-plan {
    margin-left: 0px !important;

    .quote {
      width: 100% !important;
    }
  }

  .myplan {
    .card {
      border-radius: 25px;
      background-color: #ffffff;
      border: none;
      // box-shadow: 0px 3px 6px rgb(0 0 0 / 16%) !important;
    }

    .visible-mobile {
      .row {
        @media screen and (max-width: $mobileBreak) {
          width: 100%;
          justify-content: space-between;
          margin: 0;
        }
      }
    }

    &__plan {
      text-align: center;
      margin-left: -18px;

      h6 {
        font-size: 16px;
        font-weight: 600;
        color: #0855c4;
        margin-bottom: -4px;
      }

      p {
        font-size: 10px;
        color: #15ce75;
        line-height: 10px;
        // margin-left: 12px;
        margin-bottom: 0;

        &.freezed {
          color: #ea0b90;
        }
      }

      span {
        color: #5d5d5d;
        font-size: 8.5px;
        padding-left: 4px;
      }

      .devolution-total {
        margin-top: 3px;

        h6 {
          color: #15ce75;
          font-size: 12px;
          font-weight: 500;
          line-height: 17px;
          margin-left: 7px;
        }

        span {
          margin-left: 5px;
        }
      }
    }

    &__month {
      text-align: center;
      margin-left: 15px;

      @media screen and (max-width: $mobileBreak) {
        margin: 0;
      }

      p {
        font-size: 12px;
        color: #707070;
        font-weight: 600;
        margin-bottom: 0px;
      }

      h1 {
        font-weight: bold;
        color: #0855c4;
        line-height: 5px;
        line-height: 30px;

        @media (max-width: $mobileBreak) {
          font-size: 25px;
        }

        @media (min-width: 390px) {
          font-size: 23px;
        }

        @media (min-width: 375px) {
          font-size: 23px;
        }
      }

      p:nth-child(3) {
        background-color: #0855c4;
        color: #ffffff;
        background-size: 18px;
        text-align: center;
        font-size: 12px;
        border-radius: 5px;
        font-weight: 400;
      }
    }

    &__date {
      margin-left: 27px;
      font-size: 12px;
      color: #5d5d5d;
      font-weight: 400;

      @media screen and (max-width: $mobileBreak) {
        margin: 0;
      }

      span {
        word-spacing: 3px;
        position: absolute;
      }

      .status {
        color: #15ce75;
        font-size: 12px;
        position: absolute;
        margin-bottom: 0 !important;
        display: flex;
        text-align: center;
        align-items: center;
        margin-top: 20px;
        margin-left: 30px;
      }

      span:nth-child(2) {
        margin-left: 35px;
      }

      span:nth-child(5) {
        margin-left: 35px !important;
      }

      button {
        border: none;
        outline: none;
        margin-top: 37px;
        margin-left: -25px;
        background-color: #fff;
      }

      .iconZone {
        color: #15ce75;
      }
    }
  }

  .pay {
    margin-top: 28px;

    &__title {
      span {
        color: #0855c4;
        font-size: 15px;
        font-weight: 600;
        margin-left: 10px !important;
      }
    }

    .details {
      display: flex;
      justify-content: space-between;

      .money {
        height: 43px;
      }

      .title {
        .info {
          margin: auto;
          text-align: center;
          align-items: center;
          background-color: #e9fcff;
          width: 114px;
          height: 55px;

          &__txt {
            color: #0855c4;
            font-size: 12px;
            font-weight: 500;
            padding-top: 6px;
          }

          &__subtitle {
            color: #0855c4;
            font-size: 20px;
            font-weight: 900;
          }
        }

        &__content {
          text-align: center;
          color: #707070;
          font-size: 12px;
          font-weight: 400;
        }
      }

      .action {
        display: flex;
        padding-top: 20px;
      }
    }

    &__chart {
      background-color: #ffffff;
      border-radius: 25px;
      padding: 28px;
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

      .chart {
        height: 175px;

        .card {
          box-shadow: none;

          .card-body {
            padding: 0;
          }
        }

        .infoAport {
          display: flex;
          justify-content: space-between;
          position: relative;
          top: -18px;

          span {
            font-size: 10px;
            color: #0855c4;
            margin-left: 55px;
            line-height: 10px;

            &.transparent {
              color: transparent !important;
            }
          }

          span:last-child {
            margin-right: 20px;
          }
        }
      }
    }
  }

  .modifyaport {
    .card {
      border-radius: 25px;
      height: 140px;
      box-shadow: 0px 3px 6px #00000029 !important;
    }

    &__content {
      display: flex;
      align-items: center;

      .title {
        margin-left: 18px;
        margin-right: auto;
      }

      i {
        position: absolute;
        margin-left: 83%;
        color: #0855c4;
        font-weight: 600 !important;
        top: 30px;
      }

      span {
        color: #707070;
        font-size: 15px;
        display: block;
      }

      span:last-child {
        color: #15ce75;
        font-size: 10px;
      }

      span:nth-child(2) {
        color: #15ce75 !important;
        font-size: 10px !important;
      }

      button {
        width: 50px !important;
        height: 35px !important;
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 15px;
        background-color: #ffffff;
        border: none !important;
        outline: none !important;
      }
    }

    &__txt {
      span {
        color: #0855c4 !important;
        position: absolute;
        margin-top: 22px;
        margin-left: -42px;
      }
    }

    // &__slider {
    //     margin-left: 26px;

    //     .amount-selector {
    //         display: flex;
    //         flex-wrap: wrap;
    //         justify-content: space-between;
    //         max-width: 190px;
    //         margin-top: 30px;
    //         margin-left: auto;
    //         margin-right: auto;

    //         span {
    //             font-size: 18px;
    //             color: #7b7c9a;
    //             position: relative;
    //         }

    //         .min {
    //             margin-left: 0 !important;
    //             color: #707070 !important;
    //             font-size: 11px !important;
    //         }

    //         .vue-slider-rail {
    //             height: 6px;
    //             color: #c8c8c8;
    //             border-radius: 10px;
    //         }

    //         input {
    //             width: 100%;
    //         }

    //         .vue-slider {
    //             padding: 0 !important;
    //         }

    //         .vue-slider-dot-handle {
    //             border: 8px solid #6a98db;
    //             border-radius: 50%;
    //             width: 12px;
    //             height: 12px;
    //             margin-top: 4px;
    //         }

    //         .vue-slider .vue-slider-dot .vue-slider-dot-tooltip .vue-slider-dot-tooltip-inner .vue-slider-dot-tooltip-text {
    //             font-size: 12px;
    //             color: #0855c4;
    //             font-weight: 900 !important;
    //             margin-right: 12px !important;
    //         }

    //         .vue-slider .vue-slider-dot .vue-slider-dot-tooltip .vue-slider-dot-tooltip-inner .vue-slider-dot-tooltip-text {
    //             top: 16px;
    //         }

    //         .vue-slider-dot-tooltip-inner {
    //             border-color: transparent !important;
    //             background-color: transparent !important;
    //             box-shadow: none !important;
    //             font-weight: 500;
    //         }

    //         .vue-slider-process {
    //             border-radius: 10px;
    //         }
    //     }
    // }
  }

  .freezeplan {
    .card {
      border-radius: 25px;
      height: 96px;
      box-shadow: 0px 3px 6px #00000029 !important;
    }

    &__content {
      display: flex;
      align-items: center;

      .title {
        margin-left: 18px;
        margin-right: auto;
      }

      i {
        position: absolute;
        margin-left: 83%;
        color: #0855c4;
        font-weight: 600 !important;
        top: 30px;
      }

      span {
        color: #707070;
        font-size: 15px;
        display: block;
      }

      span:nth-child(2) {
        color: #15ce75 !important;
        font-size: 10px !important;
      }

      span:last-child {
        color: #15ce75;
        font-size: 10px;
      }

      button {
        width: 50px !important;
        height: 35px !important;
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 15px;
        background-color: #ffffff;
        border: none !important;
        outline: none !important;
      }
    }

    &__txt {
      span {
        color: #0855c4 !important;
        position: absolute;
        margin-top: 22px;
        margin-left: -42px;
        width: 50px !important;
        height: 35px !important;
      }
    }
  }

  .abboutplan {
    .card {
      border-radius: 25px;
      height: 120px;
    }

    &__content {
      display: block;

      img {
        position: absolute;
      }

      span {
        color: #707070;
        font-size: 12px;
        display: block;
        font-size: 12px;
        padding-left: 70px;
      }

      span:nth-child(1) {
        color: #00adee !important;
      }

      .save {
        margin-top: 08px !important;
      }
    }
  }

  /*ESTILOS CON FLEX*/

  .option {
    .card {
      .card-body {
        border-radius: 25px;
        box-shadow: 0px 3px 6px #00000029 !important;
      }
    }

    &__content {
      display: flex;
      color: #707070;
      font-size: 10px;

      .description {
        &__title {
          color: #707070;
          font-size: 15px;
        }

        &__subtitle {
          color: #707070;
          font-size: 15px;
          line-height: 15px;
        }

        &__content {
          color: #707070;
          font-size: 12px;
          margin-top: 4px;
        }
      }

      .icon {
        margin-right: 20px;
      }

      .action {
        margin-left: auto;
      }
    }
  }

  .changecard {
    .card {
      .card-body {
        border-radius: 25px;
        box-shadow: 0px 3px 6px #00000029 !important;
      }
    }

    &__content {
      display: flex;

      .description {
        &__title-pink {
          color: #ea0b90;
          font-size: 15px;
          font-weight: 500;
        }

        &__subtitle {
          color: #707070;
          font-size: 15px;
        }
      }

      .credit-card {
        margin-right: 20px;
      }

      .action {
        margin-left: auto;
      }
    }
  }

  .additionalaport {
    .card {
      .card-body {
        border-radius: 25px;
        box-shadow: 0px 3px 6px #00000029 !important;
      }
    }

    &__content {
      display: flex;

      .description {
        &__title {
          color: #707070;
          font-size: 15px;
        }
      }

      .save {
        margin-right: 20px;
      }

      .action {
        margin-left: auto;
      }
    }

    &__slider {
      padding-left: 67px;

      .amount-selector {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        max-width: 190px;

        span {
          font-size: 18px;
          color: #7b7c9a;
          position: relative;
        }

        .min {
          margin-left: 0 !important;
          color: #707070;
          font-size: 11px;
        }

        .vue-slider-rail {
          height: 6px;
          color: #c8c8c8;
          border-radius: 10px;
        }

        input {
          width: 100%;
        }

        .vue-slider {
          padding: 0 !important;
        }

        .vue-slider-dot-handle {
          border: 8px solid #6a98db;
          border-radius: 50%;
          width: 12px;
          margin-top: 4px;
        }

        .vue-slider
        .vue-slider-dot
        .vue-slider-dot-tooltip
        .vue-slider-dot-tooltip-inner
        .vue-slider-dot-tooltip-text {
          font-size: 12px;
          color: #0855c4;
          font-weight: 900 !important;
          margin-right: 12px !important;
        }

        .vue-slider-process {
          border-radius: 10px;
        }

        .additionalaport {
          .amount-selector {
            margin-left: 66px !important;
          }
        }
      }
    }
  }

  .modal-login {
    // justify-content: center !important;

    &__txt {
      p {
        color: #0855c4;
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 0;
        line-height: 20px;
        text-align: center;
        padding-bottom: 5px;
      }

      span {
        color: #707070;
        font-size: 9.5px;
        line-height: 14px;
        display: flex;
        text-align: left;
      }

      // span:last-child {
      //     line-height: 7px !important;
      // }
    }

    &__buttons {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;

      .cancel {
        background-color: #707070;
        color: #ffffff;
        width: 85px;
        height: 20px;
        font-size: 13px;
        border: none;
        outline: none;
        border-radius: 5px;
        margin-left: 32px;
      }

      .accept {
        background-color: #0855c4;
        color: #ffffff;
        width: 85px;
        height: 20px;
        font-size: 13px;
        border: none;
        outline: none;
        border-radius: 5px;
        margin-right: 32px;
      }
    }

    .modal-dialog {
      .modal-content {
        .modal-header {
          background-color: #ffffff !important;
        }
      }
    }

    .modal-content {
      width: 369px !important;
      border-radius: 25px !important;

      .modal-header {
        display: none !important;
      }

      .modal-footer {
        display: none !important;
      }
    }
  }

  .modal-ZoneC {
    justify-content: center !important;

    &__txt {
      line-height: 12px;

      p {
        color: #0855c4;
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 0;
        line-height: 20px;
        text-align: center;
        padding-bottom: 5px;
      }

      span {
        color: #707070;
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        display: flex;
        justify-content: center;
      }

      p:last-child {
        line-height: 7px !important;
        color: #707070;
        font-size: 10px;
        font-weight: normal !important;
      }
    }

    &__btn {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;

      .cancel {
        background-color: #707070;
        color: #ffffff;
        width: 85px;
        height: 20px;
        font-size: 13px;
        border: none;
        outline: none;
        border-radius: 5px;
        margin-left: 32px;
      }

      .accept {
        background-color: #0855c4;
        color: #ffffff;
        width: 85px;
        height: 20px;
        font-size: 13px;
        border: none;
        outline: none;
        border-radius: 5px;
        margin-right: 32px;
      }
    }

    .modal-dialog {
      .modal-content {
        .modal-header {
          background-color: #ffffff !important;
        }

        .modal-body {
          padding: 30px !important;
        }
      }
    }

    .modal-content {
      width: 369px !important;
      border-radius: 25px !important;

      .modal-header {
        display: none !important;
      }

      .modal-footer {
        display: none !important;
      }
    }
  }

  .zone-client {
    &__title {
      span {
        color: #707070;
        font-size: 15px !important;
        font-weight: 500;
        margin-left: 0px;
      }

      span:last-child {
        color: #0855c4 !important;
        font-size: 15px;
        font-weight: 600;
        margin-left: 12px;
      }
    }

    &__apport {
      display: flex;
      margin-left: 0px !important;
      margin-top: 15px;
      padding-bottom: 15px !important;
    }

    .zone-client__join-me .custom-checkbox .custom-control-label,
    .zone-client__join-me .custom-radio .custom-control-label {
      font-size: 11px !important;
    }

    &__payments {
      .card {
        .card-body {
          span {
            @media screen and (max-width: 479px) {
              font-size: 10px;
            }
          }

          .btn-pay {
            font-size: 20px !important;
          }
        }
      }
    }
  }
}

.chart {
  .card {
    border: none !important;
  }
}

.chart-loader {
  display: flex;
  width: 100%;
  height: 175px;
  justify-content: center;
  align-items: center;
  color: $mainColor;
}

.modifyaport__slider .amount-selector .vue-slider-dot-handle {
  border: 8px solid #6a98db;
  border-radius: 50%;
  margin-top: 4px;
}

.amount-selector .vue3-slider .handle {
  width: 7px;
  height: 7px;
  top: 0px;
  background-color: #6a98db;
}

.vue3-slider {
  height: 6px;
}

.btn-request {
  width: 50px !important;
  flex: 50px 0 0;
}

/**MEDIA QUERY CHEVRON */

@media screen and (max-width: 390px) {
  .myplan {
    &__date {
      button::before {
        right: 120px;
      }
    }
  }
}

@media screen and (max-width: 393px) {
  .myplan {
    &__date {
      button::before {
        right: 120px;
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .myplan {
    &__date {
      button::before {
        right: 115px;
      }
    }
  }
}
</style>

